export const environment = {
  production: true,
  Baseurl: 'https://edusome.azurewebsites.net/api',
  Downloadurl: 'https://edusome.azurewebsites.net/UploadFiles/',
  DownloadImage: 'https://edusome.azurewebsites.net/UploadImages/',
  ResultUrl: 'https://edusome.azurewebsites.net/',
  HubUrl: 'https://edusome.azurewebsites.net/SignalR',
  institute_id: '57',
  branch_id: '298',
  AppName: 'dps',
  ClientAppName: 'Junior DPS',
  AppMode: 'prod'
};